import { render, staticRenderFns } from "./TopCigSalesTable.vue?vue&type=template&id=0efb0745&scoped=true&"
import script from "./TopCigSalesTable.vue?vue&type=script&lang=js&"
export * from "./TopCigSalesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efb0745",
  null
  
)

export default component.exports